import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

function ReactCalendar({ ...rest }) {
  return <Calendar {...rest} />;
}
export default ReactCalendar;
